export class Language {
    constructor(public name: string, public flag: string, public culture: string, public isActive: boolean){
    }
}